import Icon from '../../../../components/common/Icon/Icon';
import { IconKeys } from '../../../../components/common/Icon/IconKeys';
import S from './RecordAudioCard';
import record from '../../../../assets/images/record.png';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export default function RecordAudioFileCard({ onClick, disabled = false }: Props): JSX.Element {
  return (
    <S.Card
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Add Audio files. Browse from your computer"
    >
      <S.RecordIcon>
        <img src={record} alt="Audio Icon" />
      </S.RecordIcon>
      <S.Label>Record Audio...</S.Label>
      <S.SubLabel>Record from your computer</S.SubLabel>
    </S.Card>
  );
}
